// src/modules/components/FooterCADPro/styles.js
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const colors = {
  background: '#0A0A0A',
  backgroundAlt: '#0D0D0D',
  primary: '#00A8E8',
  primaryDark: '#0077B6',
  textPrimary: '#FFFFFF',
  textSecondary: 'rgba(255, 255, 255, 0.8)',
  textMuted: 'rgba(255, 255, 255, 0.5)',
  border: 'rgba(255, 255, 255, 0.08)',
  white: '#FFFFFF'
};

const breakpoints = {
  mobile: '576px',
  tablet: '768px',
  laptop: '1024px'
};

export const FooterContainer = styled.footer`
  background: ${colors.background};
  border-top: 1px solid ${colors.border};
  position: relative;
`;

export const FooterContent = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  padding: 3rem 1.5rem 1.5rem;
  position: relative;

  @media (max-width: ${breakpoints.mobile}) {
    padding: 2rem 1rem 1rem;
  }
`;

export const FooterMain = styled.div`
  display: grid;
  grid-template-columns: 1.2fr 1.5fr 1fr;
  gap: 3rem;
  padding-bottom: 2rem;
  border-bottom: 1px solid ${colors.border};

  @media (max-width: ${breakpoints.tablet}) {
    grid-template-columns: 1fr 1fr;
    gap: 2rem;
  }

  @media (max-width: ${breakpoints.mobile}) {
    grid-template-columns: 1fr;
    gap: 2rem;
    text-align: center;
  }
`;

export const FooterBrand = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  @media (max-width: ${breakpoints.mobile}) {
    align-items: center;
  }
`;

export const Logo = styled(Link)`
  display: inline-block;
  
  img {
    height: 32px;
    width: auto;
  }
`;

export const BrandText = styled.p`
  font-size: 0.85rem;
  color: ${colors.textMuted};
  line-height: 1.6;
  max-width: 220px;

  @media (max-width: ${breakpoints.mobile}) {
    max-width: 100%;
  }
`;

export const FooterLinks = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;

  @media (max-width: ${breakpoints.mobile}) {
    justify-items: center;
    gap: 1.5rem;
  }
`;

export const FooterLinkGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const GroupTitle = styled.h4`
  font-size: 0.75rem;
  font-weight: 700;
  color: ${colors.primary};
  text-transform: uppercase;
  letter-spacing: 0.1em;
  margin-bottom: 0.5rem;
`;

export const FooterLink = styled.a`
  color: ${colors.textMuted};
  text-decoration: none;
  font-size: 0.8rem;
  transition: color 0.3s ease;
  padding: 0.15rem 0;

  &:hover {
    color: ${colors.textPrimary};
  }
`;

export const FooterContact = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.6rem;

  @media (max-width: ${breakpoints.tablet}) {
    grid-column: span 2;
  }

  @media (max-width: ${breakpoints.mobile}) {
    grid-column: span 1;
    align-items: center;
  }
`;

export const ContactItem = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
  color: ${colors.textMuted};
  text-decoration: none;
  font-size: 0.8rem;
  transition: all 0.3s ease;

  svg {
    font-size: 0.85rem;
    color: ${colors.primary};
  }

  &:hover {
    color: ${colors.textPrimary};
  }
`;

export const FooterBottom = styled.div`
  padding-top: 1.5rem;
  text-align: center;
`;

export const Copyright = styled.p`
  font-size: 0.7rem;
  color: ${colors.textMuted};
`;